import React from 'react';
import { Form, Input, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { addKnowledgeDatabase } from '../KnowledgeDatabaseServices';
import { resolveBackendMessage } from '../../../Utils/apiMessages';
import { useGlobal } from '../../Shared/GlobalContext/GlobalContext';
import ResponsiveModal from '../../Shared/ResponsiveModal/ResponsiveModal';
import { useErrorHandler } from '../../../Hooks/useErrorHandler';

const AddKnowledgeBaseModal = ({ visible, onClose, navigate }) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const { loading, setLoading } = useGlobal();
    const { handleError } = useErrorHandler();

    const handleAddKnowledgeBase = async (values) => {
        try {
            setLoading(true);
            const response = await addKnowledgeDatabase(values);

            if (response.success) {
                const text = resolveBackendMessage(t, response);
                if (text) message.success(text);
                onClose();
                form.resetFields();
                navigate(`/knowledge-base/${response.data.id}`);
            } else {
                const text = resolveBackendMessage(t, response);
                if (text) message.error(text);
            }
        } catch (error) {
            handleError(error, form);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        onClose();
        form.resetFields();
    };

    const handleOk = () => {
        form.submit();
    };

    return (
        <ResponsiveModal
            title={t('add_knowledge_base')}
            open={visible}
            onCancel={handleCancel}
            onOk={handleOk}
            okText={t('create')}
            cancelText={t('cancel')}
            confirmLoading={loading}
            desktopWidth={520}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddKnowledgeBase}
                requiredMark
            >
                <Form.Item
                    name="name"
                    label={t('name')}
                    rules={[{ required: true, message: t('please_enter_knowledge_base_name') }]}
                >
                    <Input placeholder={t('enter_knowledge_base_name')} />
                </Form.Item>

                <Form.Item
                    name="description"
                    label={t('description')}
                >
                    <Input.TextArea
                        placeholder={t('enter_knowledge_base_description')}
                        rows={4}
                        dir="auto"
                        style={{ unicodeBidi: 'plaintext' }}
                    />
                </Form.Item>
            </Form>
        </ResponsiveModal>
    );
};

export default AddKnowledgeBaseModal;
